import { userDetails } from './AccountModel';
import Resizer from "react-image-file-resizer";

export function mapUserProviderObject(userData, providerData) {
    var user = userDetails;
    user.name = userData.name;
    user.email = userData.email;
    user.uid = userData.uid;
    user.userRole = userData.userRole;
    user.provider = providerData;
    return user;
}

export const getHoursPerWeekData = (hoursPerWeek) => {
    let result = '';
    for (const item in hoursPerWeek) {
        //console.error(item);
        if (item === "EightHours" && hoursPerWeek[item] === true) {
            result = result + '8 hrs,';
        } else if (item === "SixteenHours" && hoursPerWeek[item] === true) {
            result = result + '16 hrs,';
        } else if (item === "TwentyFourHours" && hoursPerWeek[item] === true) {
            result = result + '24 hrs,';
        } else if (item === "ThirtyTwoHours" && hoursPerWeek[item] === true) {
            result = result + '32 hrs,';
        } else if (item === "ThirtySixHours" && hoursPerWeek[item] === true) {
            result = result + '36 hrs,';
        } else if (item === "FourtyHours" && hoursPerWeek[item] === true) {
            result = result + '40 hrs,';
        } else {

        }
    }
    return result;
};

export const getPreferredContractData = (data) => {
    let result = '';
    for (const item in data) {
        if (item === "capsule" && data[item] === true) {
            result = result + 'Capsule,';
        } else if (item === "syrup" && data[item] === true) {
            result = result + 'Syrup,';
        } else {

        }
    }
    return result;
};

export const parseDate = (dateObj, includeTime = false) => {
    if (dateObj && typeof dateObj?.toDate === 'function') {
        return formatDate(dateObj.toDate(), includeTime);
    }
    if (dateObj && 'seconds' in dateObj && 'nanoseconds' in dateObj) {
        return formatDate(new Date(dateObj?.seconds * 1000 + dateObj?.nanoseconds / 1000000), includeTime);
    }
    const parsedDate = new Date(dateObj);
    return isNaN(parsedDate) ? parseFirestoreMapTimestamp(dateObj, includeTime) : formatDate(parsedDate, includeTime);
}

export const parseFirestoreMapTimestamp = (map, includeTime = false) => {
    if (!map || typeof map !== 'object') return null;

    const { _seconds, _nanoseconds } = map;
    
    if (typeof _seconds !== 'number' || typeof _nanoseconds !== 'number') {
        return null;
    }

    return formatDate(new Date(_seconds * 1000 + _nanoseconds / 1000000), includeTime);
}

export const formatDate = (date, includeTime = false) => {
    if (!(date instanceof Date) || isNaN(date)) return null;
    
    const day = String(date.getDate()).padStart(2, '0'); 
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear(); 
    
    if (!includeTime) {
        return `${day}/${month}/${year}`; // Returns DD/MM/YYYY format
    }

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`; // Returns DD/MM/YYYY HH:MM:SS format
}

export const dateFormatter = (passDate) => {
    let returnDate = new Date(passDate);
    let dd = returnDate.getDate();

    let mm = returnDate.getMonth() + 1;
    const yyyy = returnDate.getFullYear();
    if (dd < 10) {
        dd = `0${dd}`;
    }

    if (mm < 10) {
        mm = `0${mm}`;
    }
    returnDate = `${dd}/${mm}/${yyyy}`;
    return returnDate;
}

export const dateFormatterWithTime = (passDate) => {
    let returnDate = new Date(passDate);
    let dd = returnDate.getDate();
    let mm = returnDate.getMonth() + 1;
    const yyyy = returnDate.getFullYear();
    
    // Get hours, minutes, and seconds
    let hh = returnDate.getHours();
    let min = returnDate.getMinutes();
    let sec = returnDate.getSeconds();
    
    // Format single digits
    if (dd < 10) {
        dd = `0${dd}`;
    }

    if (mm < 10) {
        mm = `0${mm}`;
    }

    if (hh < 10) {
        hh = `0${hh}`;
    }

    if (min < 10) {
        min = `0${min}`;
    }

    if (sec < 10) {
        sec = `0${sec}`;
    }

    // Return date with time
    returnDate = `${dd}/${mm}/${yyyy} ${hh}:${min}:${sec}`;
    return returnDate;
}


export const dateFormatterForInvoice = (passDate) => {
    let returnDate = new Date(passDate);
    let dd = returnDate.getDate();

    let mm = returnDate.getMonth() + 1;
    const yyyy = returnDate.getFullYear();
    const yy = yyyy % 100;
    returnDate = `${mm}/${dd}/${yy}`;
    return returnDate;
}

export const getEmploymentTypeData = (data) => {
    let result = '';
    for (const item in data) {
        if (item.toLowerCase() === "capsule".toLowerCase() && data[item] === true) {
            result = result + 'Capsule,';
        } else if (item.toLowerCase() === "freelance".toLowerCase() && data[item] === true) {
            result = result + 'Freelance,';
        } else if (item.toLowerCase() === "sideProduct".toLowerCase() && data[item] === true) {
            result = result + 'Side Product,';
        } else if (item.toLowerCase() === "temporaryContract".toLowerCase() && data[item] === true) {
            result = result + 'Temporary Contract,';
        } else if (item.toLowerCase() === "internship".toLowerCase() && data[item] === true) {
            result = result + 'Internship,';
        } else if (item.toLowerCase() === "syrup".toLowerCase() && data[item] === true) {
            result = result + 'Syrup,';
        } else if (item.toLowerCase() === "traineeship".toLowerCase() && data[item] === true) {
            result = result + 'Traineeship,';
        } else if (item.toLowerCase() === "remote".toLowerCase() && data[item] === true) {
            result = result + 'Remote,';
        } else {

        }
    }
    return result;
};

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const resizeFileImage = (file) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            720,
            480,
            file.name.split('.')[file.name.split('.').length - 1],
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });

export const resizeEventFileImage = (file) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            720,
            480,
            file.name.split('.')[file.name.split('.').length - 1],
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });